/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Memory_Scope_NoteInputs */



/**
* | output |
* | --- |
* | "These notes belong to this organization only." |
*
* @param {Uno_Memory_Scope_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_memory_scope_note = /** @type {((inputs?: Uno_Memory_Scope_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Memory_Scope_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese Notizen gelten nur für diese Organisation.")
	return /** @type {LocalizedString} */ ("These notes belong to this organization only.")
});